module.exports = __webpack_public_path__ + "img/icon_08.472a7717.png";